import { createFileRoute } from "@tanstack/react-router";
import { useMe } from "@/hooks/useCloudChat";
import { OrganizationSection } from "@/features/dashboard/OrganizationSection";

/** The signed-in user's own workspace. LATO staff manage other organizations from Admin →
 *  Workspaces (the platform-admin endpoints), never by switching this page's org. */
function WorkspacePage() {
  const { data: me } = useMe();
  const orgId = me?.organization?.id ?? "";
  return <OrganizationSection orgId={orgId} />;
}

export const Route = createFileRoute("/_auth/_agents/settings/workspace")({
  component: WorkspacePage,
});
